/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_PopulationInputs */

const en_us2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compared with people who lift and log their training, not with the general population.`)
};

const pt_br2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparado com quem treina musculação e registra os treinos, não com a população em geral.`)
};

const es_419_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparado con personas que levantan pesas y registran su entrenamiento, no con la población en general.`)
};

const pt_pt2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparado com quem treina musculação e regista os treinos, não com a população em geral.`)
};

const fr_fr2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparé aux personnes qui font de la musculation et notent leurs séances, pas à la population générale.`)
};

const de_de2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verglichen mit Menschen, die Krafttraining machen und es protokollieren, nicht mit der Allgemeinbevölkerung.`)
};

const it_it2_exercise_personal_strength_population = /** @type {(inputs: Exercise_Personal_Strength_PopulationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto con chi si allena con i pesi e registra gli allenamenti, non con la popolazione generale.`)
};

/**
* | output |
* | --- |
* | "Compared with people who lift and log their training, not with the general population." |
*
* @param {Exercise_Personal_Strength_PopulationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_population = /** @type {((inputs?: Exercise_Personal_Strength_PopulationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_PopulationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_population(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_population(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_population(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_population(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_population(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_population(inputs)
	return en_us2_exercise_personal_strength_population(inputs)
});
export { exercise_personal_strength_population as "exercise-personal.strength_population" }